<script>
  export let lang
  export let text
</script>

<pre class={lang}><code>{text}</code></pre>
